<div class="form-field flex-space-around" >
    <nb-checkbox *ngFor="let option of value" [(ngModel)]="option.selected" (change)="onChangeOption(option)" [class.disabled]="disabled" >
        {{option.label}}
    </nb-checkbox>
</div>

